import React, { Component } from "react";
import { Link } from "react-router-dom";
import defaults from "../constants/defaults";
import axios from "axios";
//import { FullPage2 } from "./FullPage2";

export default class DealItem extends Component {
  _captureBannerClick =  async () => {
    const { campaign, ap, postBalance, deviceId, location, test } = this.props;
    const urlString = window.location.href;
    const url = new URL(urlString);
    const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
    const fields = {
      AccessPointID: ap.ap_mac,
      LocationID: Number(ap.ap_locationid),
      DeviceID,
      CampaignID: campaign.CampaignID,
      MediaType: "click"
    };
    try {
      if(!test) {
        const {data} = await axios.post("/impressions", { fields });
        await postBalance(campaign, "click", data);
      }
      if(campaign.opi && deviceId) {
        // opi 
        let url = `${campaign.opi.opi_url}?id=${deviceId}&carry_campaignid=${campaign.CampaignID}&carry_apmac=${ap.ap_mac}`
        location.replace(url);
      }
    } catch (err) {
      console.log("error posting /campaigns on deal item click");
    }
  }

  _redirectUser = () => {
    const { campaign, survey_ids, deviceId, ap, location } = this.props;
   
    if(campaign.survey_id) {
      if(survey_ids.length > 0) {
        if(survey_ids.find(id => id === String(campaign.survey_id))) {
          return "/content";
        }
        if(campaign.type_ad === "performance") {
          return "/content";
        }
        return "/survey";
      }
      if(campaign.type_ad === "performance") {
        return "/content";
      }
      return "/survey";
    }
    if(campaign.type_ad === "podcast") {
      return "/podcast";
    }
    return "/content";
  }

  _impressiontType = async(type) => {
    const { campaign, ap, postBalance, test } = this.props;
    const urlString = window.location.href;
    const url = new URL(urlString);
    const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
    const fields = {
      AccessPointID: ap.ap_mac,
      LocationID: Number(ap.ap_locationid),
      DeviceID,
      CampaignID: campaign.CampaignID,
      MediaType: type
    };
    try {
      if(!test) {
        const {data} = await axios.post("/impressions", { fields });
        await postBalance(campaign, "click", data);
      }
    } catch (err) {
      console.log("error posting /campaigns");
    }
  }

  render() {
    const { campaign, ap, band, survey_ids, passPortal, start_counter, search, user, threshold, userData, skip_seconds, each_seconds, deviceId,  
      portal_label_access, portal_label_return, portal_show_timer, skip_podcast, forward_audio_podcast, show_popup, ghz_condition, backgroundParam, fontColorParam, fontParam} = this.props;
    const urlString = window.location.href;
    const url = new URL(urlString);
    const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
    /* const idx = campaign.CampaignVideoURL ? campaign.CampaignVideoURL.lastIndexOf(".") : "";
    const len = campaign.CampaignVideoURL.length;
    const ext = campaign.CampaignVideoURL.substring(idx + 1, len);
    let hasVideo = true;
    if (ext === "jpeg" || ext === "jpg" || ext === "png") {
      hasVideo = false;
    } */
    return (
    <>
    <style jsx>{`
          .list-group-item {
            background-color: transparent !important;
          }
      `}</style>
      <div
      style={{
        marginTop: "8px",
      }}
    >
      <Link
        onClick={this._captureBannerClick}
        style={{
          borderWidth: "0",
          padding: '0',
          borderRadius: "20px",
        }}
        className="list-group-item list-group-item-action flex-column align-items-start"
        to={{
          pathname: (!campaign.opi && deviceId) && this._redirectUser(),
          campaign: campaign,
          DeviceID: DeviceID,
          ap,
          band,
          survey_ids,
          search: this.props.search,
          token: this.props.token,
          threshold,
          userData,
          skip_seconds,
          skip_podcast,
          each_seconds,
          portal_label_access, portal_label_return, portal_show_timer,
          start_counter,
          forward_audio_podcast,
          show_popup,
          ghz_condition,
          backgroundParam,
          fontColorParam,
          fontParam,
        }}
      >
        <div
        className="row ml-1 mr-1"
          style={{
            height: "6.8em",
            borderRadius: "20px",
            justifyContent: "center"
          }}
        >

          <div
          className="col-11"
            style={{
              height: "100%",
              borderRadius: "20px 0px 0px 20px",
              backgroundImage: `url(/google-storage/${encodeURIComponent(campaign.CampaignDealItemURL)})`,
              backgroundPosition: "center",
              backgroundSize: "cover"
            }}
          >
          </div>

          <button className="btn btn-lg btn-danger col-1" 
          style={{
            height: "100%",
            textAlign: "center",
            padding: 0,
            borderRadius: "0px 20px 20px 0px"
          }}>&raquo;</button>
         
        </div>
      </Link>
      </div>

    </>
    );
  }
}
